<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide" persistent>
    <ml-dialog-content hideClose rowActions>
      <template #title>
        <ml-element-icon
          class="q-mr-sm"
          :size="32"
          icon="fiber_new"
          color="primary"
        ></ml-element-icon>
        {{ title }}
      </template>
      <template #content>
        <div>{{ content }}</div>
      </template>
      <template #actions>
        <ml-element-button
          :loading="loading"
          :label="buttonText"
          @click="onOKClick"
        />
      </template>
    </ml-dialog-content>
  </q-dialog>
</template>
<script setup lang="ts">
import { useDialogPluginComponent } from 'quasar'
import { ref } from 'vue'

import MlDialogContent from 'components/blocks/dialog/MlDialogContent.vue'
import MlElementButton from 'components/elements/buttons/MlElementButton.vue'
import MlElementIcon from 'components/elements/icons/MlElementIcon.vue'

const loading = ref(false)

defineProps<{
  content?: string
  title?: string
  buttonText?: string
}>()

defineEmits([...useDialogPluginComponent.emits])
const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent()

async function onOKClick() {
  loading.value = true
  onDialogOK()
}
</script>
